import { Injectable, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RedirectService implements OnInit {
  redirectUrl: string = null;

  constructor(private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
  }

  saveQueryParams() {
    const redirectView = this.route.snapshot.queryParamMap.get('view');
    if (redirectView != undefined) {
      this.redirectUrl = redirectView;
    }
  }

  processRedirect(role) {
    this.router.navigateByUrl('/' + role + '/' + this.redirectUrl);
    this.redirectUrl = null;
  }

}
